import RepositoryService from 'src/services/repository'

const resource = 'multiProject/version'

export default RepositoryService.utils.createCrudRepository(resource)
